import React, { useEffect } from "react";
import ReactPlayer from "react-player";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import GrEmptyState from "src/design-system/components/GrEmptyState";
import GrIcon from "src/design-system/components/GrIcon";
import icons from "src/design-system/icons";

const ReactVideoPlayer = (props) => {
  const { userInfo } = useContentSetting();
  // A link the player cannot play (deleted or private video, wrong URL) shows a calm message in the
  // same 16:9 space instead of an empty box. `compactFailed`: the message takes only the space it
  // needs (no 16:9 box), e.g. inside a popup.
  const [failed, setFailed] = React.useState(false);
  useEffect(() => setFailed(false), [props.url]);

  const setVideoPlayed = () => {
    if (props.setting && props.setting.video_type !== "repeat") {
      localStorage.setItem("is_seen_video", "Yes");
    }
  };
  const setVideoPlayedSec = (e) => {
    let dataKey = props.id;
    let _url = props.url;
    let user_id = userInfo?._id;
    let user_Info = localStorage.getItem(`${user_id}`);
    let data = {};
    if (user_Info) {
      data = JSON.parse(user_Info);
    }
    data[dataKey] = {
      url: _url,
      playedSec: e.playedSeconds,
    };

    localStorage.setItem(`${user_id}`, JSON.stringify(data));
  };
  if (failed && props.compactFailed) {
    return (
      <GrEmptyState
        compact
        icon={<GrIcon icon={icons.video} />}
        title="This video is not available right now."
      />
    );
  }
  return (
    <div className="wrapper">
      {failed ? (
        <GrEmptyState
          compact
          icon={<GrIcon icon={icons.video} />}
          title="This video is not available right now."
          sx={{ position: "absolute", inset: 0, justifyContent: "center" }}
        />
      ) : (
        <ReactPlayer
          controls
          className="player"
          url={props.url}
          width="100%"
          height="100%"
          stopOnUnmount
          pip
          playsinline
          onPlay={setVideoPlayed}
          onProgress={setVideoPlayedSec}
          onError={(error, data) => {
            // HLS streams also report small errors they recover from (data.fatal === false).
            if (data?.fatal === false) return;
            setFailed(true);
          }}
        />
      )}
    </div>
  );
};

export default ReactVideoPlayer;
